import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { assertionClient } from '../client/assertionClient';

type Options = {

};

const defaultOptions: Partial<Options> = {
};

export const useNextAssertion = (options: Partial<Options> = defaultOptions) => {
  const { data: { data: next } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getNextAssertion],
    queryFn: () => assertionClient.getNextAssertion(),
  });

  return {
    ...rest,
    next,
  };
};
